/**
 * Downloads specific third-party images inside of an activity object.
 *
 * @param {unknown} activity - can be a write, questionnaire or pedagogical content activity.
 * @returns {Promise<void>} A Promise that resolves after downloading the images.
 * @throws {TypeError} If the activity is not a valid type.
 */
async function downloadThirdPartyImages(activity: unknown): Promise<void> {
  const imageSourceRegexp = /https?:\/\/[^\s"']+\.[a-z]{2,}(?:\/[^\s"']*)?/gi;

  const thirdPartyImageUrls = JSON.stringify(activity).match(imageSourceRegexp);
  const thirdPartyImageRequests = thirdPartyImageUrls?.map(
    async (imageUrl: string) => {
      if (imageUrl.includes('media.letrus')) {
        await fetch(imageUrl, {
          mode: 'no-cors',
        });
      }
    },
  );

  await Promise.all(thirdPartyImageRequests ?? []);
}

export default downloadThirdPartyImages;
